<svelte:head>
  <title>Pending review | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-missing-attribute -->

<table class="table is-fullwidth is-hoverable" style="max-width:100%;table-layout:fixed;">
  <tbody>
    {#each items as item}
          <ItemCard { item } />
    {/each}
  </tbody>
</table>

<script lang="ts">
  import ItemCard from "./_components/ItemCard.svelte";
  import { offerSearchTerm } from './stores';
  import { searchAndFilterOffers } from './utils/searchAndFilterOffers';
  import { appState } from "../../../lib/appState";

  let allItems : Offer_v2_Doc[] = [];

  let delegatedCompanies : string[] | undefined = [];

  let sortField = '';
  let sortAsc = true;

  $: items = searchAndFilterOffers({
    sortField: sortField,
    sortAsc: sortAsc,
    items: allItems,
    searchTerm: $offerSearchTerm,
    delegatedCompanies: delegatedCompanies
  });

  let firebase = window.firebase;

  getOffers();
  getDelegatedCompanies();

  async function getOffers() {
    firebase
      .firestore()
      .collection("offers_v2")
      .where('status', '==', 'pending-approval')
      .onSnapshot((snap) => {
        allItems = snap.docs.map(doc => ({ id: doc.id, data: doc.data() }) as Offer_v2_Doc).sort((a, b) => b.data.created > a.data.created ? 1 : -1);;
      });
  }

  async function getDelegatedCompanies() {
    if($appState.user?.isDelegatedAdmin && $appState.user?.delegatedAdminTag) {
      firebase
        .firestore()
        .collection("companies_v1")
        .where("tags", "array-contains", $appState.user.delegatedAdminTag)
        .onSnapshot((snap) => {
          delegatedCompanies = snap.docs.map(
            (doc) => (doc.id)
          );
        });
    }
    else if ($appState.user?.isFullAdmin) {
      delegatedCompanies = undefined;
    }
    else {
      delegatedCompanies = [];
    }
  }
</script>